import { module } from 'modujs'
import gsap from "gsap";
import { SplitText } from 'gsap/SplitText';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(SplitText)
gsap.registerPlugin(ScrollTrigger)

export default class extends module {
    constructor(m) {
        super(m);
        this.$description = this.$("description")[0]
        this.$title = this.$("title")[0]
        this.$textIndicator = this.$("textIndicator")[0]
        this.$indicator = this.$("indicator")[0]
        this.split();
        this.computeMetrics();
        this.resize = this.onResize.bind(this);
        this.masks = new Array();
    }

    init() {
        window.addEventListener("resize", this.resize)
        this.introAnimation();
    }

    split() {
        this.splitDescription = new SplitText(this.$description, {type: "lines"});
        this.splitTitle = new SplitText(this.$title, {type: "lines, chars", charsClass: "c-split-text_char"})
        this.splitTextIndicator = new SplitText(this.$textIndicator, {type: "lines, chars"})
    }

    introAnimation() {
        gsap.fromTo(this.splitTitle.chars,
            {
                y: '60%',
                opacity: 0
            },
            {
                y: '0',
                opacity: 1,
                stagger: {
                    each: 0.02,
                },
                duration: 1,
                ease: "power3.out"
            }
        )

        gsap.fromTo(this.splitTextIndicator.chars,
            {
                y: 10,
                opacity: 0
            },
            {
                y: '0',
                opacity: 1,
                stagger: {
                    each: 0.01,
                    from: "center",
                },
                duration: 0.5,
                delay: 0.5,
                ease: "power3.out"
            }
        )

    }

    onScrollProgress(progress) {
        this.$indicator.style.setProperty('--progress', progress);
        this.splitDescription.lines.forEach((line, i) => line.style.setProperty('--progress', this.computeProgress(progress, i)))
    }

    computeProgress(progress, index){
        const { from, to } =  this.metrics[index];
        const clampedProgress = gsap.utils.clamp(0, 1, gsap.utils.mapRange(from, to, 0, 1, progress))
        return clampedProgress
    }

    computeMetrics() {
        const widths = this.splitDescription.lines.map(line => line.getBoundingClientRect().width)
        const totalWidth = widths.reduce((total, width) => {return total += width}, 0);
        let widthIncrementor = 0;
        this.metrics = this.splitDescription.lines.map((line, i) => {
            const from = widthIncrementor / totalWidth;
            const ratio = widths[i] / totalWidth;
            widthIncrementor+= widths[i];
            return {
                from: from,
                to: from + ratio
            }
        })
    }

    onResize() {
        this.splitDescription.revert();
        this.splitTitle.revert();
        this.splitTextIndicator.revert();
        this.masks.forEach(mask => mask.remove())
        this.masks = []
        this.split();
        this.computeMetrics();
        window.requestAnimationFrame( () => {
            this.$indicator = this.el.querySelector("[data-intro-experience='indicator']")
            this.$indicator.style.setProperty('--progress', 0);
        })
    }

    destroy() {
        window.removeEventListener("resize", this.resize)
    }
}
